module.exports = __webpack_public_path__ + "img/Ayandeh.1b4649c1.svg";